module.exports = __webpack_public_path__ + "static/media/sass.470548b4.svg";